import React from 'react';
import { List } from 'semantic-ui-react';

const ErrorToastItems = ({ errors }) => (
  errors.map((error, index) => (
    <List.Header
        // eslint-disable-next-line
      key={`error_toast_item_${index}`}
      content={error}
    />
  ))
);

export default ErrorToastItems;
